import { Box, Grid, TextField, InputAdornment, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Chip } from "@mui/material";
import { Button, ButtonGroup } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SubjectIcon from "@mui/icons-material/Subject";
import AppBreadcrumbs from "../../../components/AppBreadcrumbs";
import * as services from "../../../services/saleng";
import { useState, useEffect } from "react";
import { formatNumber } from "../../../utils/formatNumber";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "moment/locale/th";

moment.locale("th");

export default function TransformTransactionsTemplate() {
  const navigate = useNavigate();

  const [salesTransaction, setSalesTransaction] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);
      try {
        const res = await services.getPurchaseTransactions();
        console.log("res", res);
        const transactionRes = res.data.data;
        setSalesTransaction(transactionRes || []);
      } catch (err) {
        setError(err.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const rows = salesTransaction.map((t, index) => {
    return {
      id: index,
      transactionId:t.transactionId,
      billNumber: t.billNumber,
      customerName: t.customerName,
      status: t.status,
      paymentMethod: t.paymentMethod ?? "-",
      totalNetPrice: formatNumber(t.totalNetPrice || 0),
      createdAt: moment(t.createdAt)
        .add(543, "year")
        .format("D MMM YYYY เวลา HH:mm"),
      createdAtDateOnly: moment(t.updatedAt).format("YYYY-MM-DD"),
    };
  });

  const columns = [
    { field: "billNumber", headerName: "หมายเลขบิล", flex: 2 },
    { field: "customerName", headerName: "ชื่อซัพพลายเออร์", flex: 2.5 },
    {
      field: "paymentMethod",
      headerName: "วิธีการชำระเงิน",
      flex: 1.5,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalNetPrice",
      headerName: "ราคาสุทธิ",
      type: "number",
      flex: 1.5,
    },
    {
      field: "status",
      headerName: "สถานะ",
      flex: 1.5,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const value = params.value;

        // กำหนดสีตามสถานะ
        const getColor = (status) => {
          switch (status?.toLowerCase()) {
            case "payed":
              return "success";
            case "waiting":
              return "warning";
            case "cancel":
              return "error";
            default:
              return "default";
          }
        };

        return (
          <Chip
            label={value || "-"}
            color={getColor(value)}
            // variant="outlined"
          />
        );
      },
    },
    { field: "createdAt", headerName: "วันเปิดบิล", flex: 2 },
    {
      field: "description",
      headerName: "ข้อมูลเพิ่มเติม",
      flex: 0,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <SubjectIcon
            onClick={() => navigate("/reports/purchases/" + params.row.transactionId)}
          />
        );
      },
    },
  ];

  const filteredRows = rows.filter((row) => {
    const matchesSearch =
      row.billNumber.toLowerCase().includes(search.toLowerCase()) ||
      row.customerName.toLowerCase().includes(search.toLowerCase()) ||
      row.paymentMethod.toLowerCase().includes(search.toLowerCase());

    const matchesDate = !searchDate || row.createdAtDateOnly === searchDate;

    const matchesStatus =
      !statusFilter || row.status?.toLowerCase() === statusFilter.toLowerCase();

    return matchesSearch && matchesDate && matchesStatus;
  });

  if (loading) return <Box sx={{ p: 2 }}>Loading inventory...</Box>;
  if (error) return <Box sx={{ p: 2, color: "red" }}>Error: {error}</Box>;

  return (
    <Box p={2}>
      <AppBreadcrumbs />

      <Grid
        container
        alignItems="center"
        justifyContent={"space-between"}
        sx={{ my: 2 }}
      >
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            placeholder="ค้นหารายละเอียด"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item>
          <TextField
            label="ค้นหาวัน"
            type="date"
            value={searchDate}
            onChange={(e) => setSearchDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: 200 }}
          />
        </Grid>
      </Grid>

      <Grid container sx={{ my: 2 }}>
        <Grid item xs={12}>
          <ButtonGroup variant="outlined" color="success">
            <Button
              variant={statusFilter === "" ? "contained" : "outlined"}
              onClick={() => setStatusFilter("")}
            >
              ทั้งหมด
            </Button>
            <Button
              variant={statusFilter === "sent" ? "contained" : "outlined"}
              onClick={() => setStatusFilter("sent")}
            >
              ส่ง
            </Button>
            <Button
              variant={statusFilter === "waiting" ? "contained" : "outlined"}
              onClick={() => setStatusFilter("waiting")}
            >
              รอดำเนินการ
            </Button>
            <Button
              variant={statusFilter === "payed" ? "contained" : "outlined"}
              onClick={() => setStatusFilter("payed")}
            >
              สำเร็จ
            </Button>
            <Button
              variant={statusFilter === "cancel" ? "contained" : "outlined"}
              onClick={() => setStatusFilter("cancel")}
            >
              ยกเลิก
            </Button>
          </ButtonGroup>
        </Grid>
      </Grid>

      <Paper sx={{ mt: 2 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            loading={loading}
            disableRowSelectionOnClick
            localeText={{ noRowsLabel: "ไม่พบข้อมูล" }}
          />
        </div>
      </Paper>
    </Box>
  );
}
